

























































































import Vue from 'vue'
import { createComponent, onMounted, ref, computed, watch, Ref } from '@vue/composition-api'
import { useStore } from '@/hooks/common'
import {
    IFileItem,
    // getFileListByName,
    getFileListByNameAndTime,
    mkdir,
    copyMoveFile,
} from '../service/public'
import { BreadcrumbItem } from '../store/public'
import { Message, Input } from 'element-ui'
interface DialogType {
    dialogVisible: boolean
    dataType: 'multi' | 'single'
    file: IFileItem
    multiFile: IFileItem[]
}

export default createComponent({
    props: {
        dialogVisible: {
            type: Boolean,
            default: () => false,
        },
        dataType: {
            type: String,
            default: () => 'multi',
        },
        file: {
            type: Object,
            default: () => {},
        },
        multiFile: {
            type: Array,
            default: () => [],
        },
    },
    setup(props: DialogType, setupContext) {
        const fileList = ref<IFileItem[]>([])
        const newFileRef = ref<Input>(void null)
        const loading = ref<boolean>(true)
        const { breadData, setBreadData, clickBread } = handleBread(fileList)
        const {
            cancelCreateDir,
            confirmCreateDir,
            createDirClick,
            newDirName,
            createButtonClick,
            newDirError,
            clearErrorMsg,
        } = handleNewDir(fileList, newFileRef, breadData)
        const defaultBreadData = [
            {
                id: '0',
                name: '全部文件',
                path: '',
            },
        ]
        const boxTypeMap = {
            move: '移动',
            copy: '复制',
        }
        const dialogShow = computed({
            get: () => props.dialogVisible,
            set: val => {
                if (!val) {
                    setupContext.emit('close-dialog')
                }
            },
        })
        const isRootDir = computed(() => {
            const dirId = breadData.value.length > 0 ? breadData.value[breadData.value.length - 1].id : ''

            return !dirId || dirId === '0'
        })
        watch(
            () => dialogShow.value,
            async val => {
                if (val) {
                    loading.value = true
                    fileList.value = await getFileDirs()
                    loading.value = false
                } else {
                    setupContext.emit('close-dialog')
                    breadData.value = defaultBreadData
                    fileList.value = []
                    newDirError.value = false
                    newDirName.value = '新建文件夹'
                    createButtonClick.value = false
                }
            },
            {
                lazy: true,
            }
        )
        onMounted(async () => {
            loading.value = true
            fileList.value = await getFileDirs()
            breadData.value = defaultBreadData
            loading.value = false
        })
        const toNextLevel = async (dir: IFileItem) => {
            loading.value = true
            fileList.value = await getFileDirs(dir.id)
            const lastFile: BreadcrumbItem = {
                id: dir.id,
                name: dir.name,
                path: '',
            }
            setBreadData(lastFile)
            loading.value = false
        }
        const handleMoveOrCopy = async () => {
            let postData: IFileItem[] = []
            const dirId = breadData.value.length > 0 ? breadData.value[breadData.value.length - 1].id : '' // 目标文件夹字段，可保留
            if (props.dataType === 'multi') {
                postData = props.multiFile
            } else {
                postData.push(props.file)
            }
            const currentDirId = setupContext.root.$route.query.id
            const target = {
                id: dirId,
                name: '',
            }
            const params = {
                list: postData,
                currentDirId,
                target,
            }
            setupContext.emit('copy-file', params)
        }
        const clickBreadClear = async (chosedBread: BreadcrumbItem) => {
            await clickBread(chosedBread)
            cancelCreateDir()
        }
        return {
            fileList,
            dialogShow,
            breadData,
            toNextLevel,
            clickBread,
            cancelCreateDir,
            confirmCreateDir,
            createDirClick,
            newDirName,
            createButtonClick,
            newDirError,
            handleMoveOrCopy,
            newFileRef,
            clearErrorMsg,
            clickBreadClear,
            loading,
            isRootDir,
        }
    },
})
function handleNewDir(fileList: Ref<IFileItem[]>, newFileRef: Ref<Input>, dirs: Ref<BreadcrumbItem[]>) {
    const newDirName = ref<string>('新建文件夹')
    const createButtonClick = ref<boolean>(false)
    const newDirError = ref<boolean>(false)

    function clearErrorMsg() {
        if (newDirError.value === true) {
            newDirError.value = false
        }
    }
    function createDirClick() {
        //点击新建

        const index = fileList.value.findIndex(item => {
            return item.id === 'createNewDir'
        })
        if (index === -1) {
            fileList.value.unshift({
                id: 'createNewDir',
                name: '新建文件夹',
                isFile: false,
                createTime: '',
                size: '-',
                createUser: '-',
            })
            createButtonClick.value = true
            // 组件没更新，拿不到组件实例，root.$nextTick函数不知道3.0会不会有，所以先用setTimeout代替
            setTimeout(() => {
                newFileRef.value.select()
            }, 0)
        }
    }
    async function confirmCreateDir() {
        if (!dirs.value.length) {
            Message.error('当前文件路径不存在！')
            return
        }
        const name = newDirName.value as any
        if (typeof name === 'undefined' || name.trim() === '') {
            newDirError.value = true
            return
        }
        // eslint-disable-next-line no-useless-escape
        const reg = /^[\(\)0-9a-zA-Z\u4e00-\u9fa5_（）-]+$/
        if (!reg.test(name)) {
            Message.error('名称只能包含数字字母汉字、下划线、横线和括号')
            return
        }
        const currentDirId = dirs.value[dirs.value.length - 1].id
        const parentId = currentDirId
        const postData = {
            parentId,
            name,
        }
        const res = await mkdir(postData)
        if (res && res.code === 0) {
            Message.success(res.desc)
            fileList.value = await getFileDirs(parentId)
            newDirName.value = '新建文件夹'
            createButtonClick.value = false
        } else {
            const eMsg = res && res.desc ? res.desc : '新建文件夹失败'
            Message.error(eMsg)
            // newDirError.value = true;
        }
    }

    function cancelCreateDir() {
        createButtonClick.value = false
        if (fileList.value.length > 0 && fileList.value[0].id === 'createNewDir') {
            fileList.value.shift()
        }
        newDirError.value = false
        newDirName.value = '新建文件夹'
        createButtonClick.value = false
    }
    return {
        cancelCreateDir,
        confirmCreateDir,
        createDirClick,
        newDirName,
        createButtonClick,
        newDirError,
        clearErrorMsg,
    }
}

function handleBread(fileList: Ref<IFileItem[]>) {
    const breadData = ref<BreadcrumbItem[]>([])
    function setBreadData(lastFile: BreadcrumbItem) {
        if (!lastFile.id) {
            return
        }
        const choseIndex = breadData.value.findIndex(item => {
            return item.id === lastFile.id
        })
        if (choseIndex === -1) {
            // append dir
            breadData.value = breadData.value.concat(lastFile)
        } else {
            breadData.value = breadData.value.slice(0, choseIndex + 1)
        }
    }
    async function clickBread(chosedBread: BreadcrumbItem) {
        fileList.value = await getFileDirs(chosedBread.id)
        setBreadData(chosedBread)
    }
    return { breadData, clickBread, setBreadData }
}

async function getFileDirs(id?: string) {
    id = id ? id : '0'
    let currentData: IFileItem[] = []
    try {
        const reqParams = {
            id,
            current: 1,
            size: 1000, // 全量数据暂时设为1000 不分页
            name: '',
            start: '',
            end: '',
        }
        const currentDirData = await getFileListByNameAndTime(reqParams)
        if (currentDirData.code === 0) {
            currentData = currentDirData.data as IFileItem[]
            // 存当前文件夹的文件内容
        } else {
            Message.error(currentDirData.desc || '文件列表查询失败')
        }
    } catch (e) {
        Message.error('文件列表查询失败')
    }
    if (currentData.length > 0) {
        currentData = currentData.filter(item => {
            return !item.isFile
        })
    }
    return currentData
}
